module.exports = __webpack_public_path__ + "img/pleisure_bodyimage06-8.ed895a45.jpg";